import { RouteRecordRaw } from 'vue-router';

let routes: RouteRecordRaw[] = [
    {
        path: '/users',
        name: 'users',
        meta: { sideMenuLabel: "Utenti" },
        component: () => import("./views/users.vue")
    },
    {
        path: '/users/:identifier',
        name: 'usersDetail',
        meta: { classes: "" },
        component: () => import("./views/usersDetail.vue")
    }
];

export default routes;